import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesGastos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Gastos", items: [
      { label: "Gastos", icon: "fas fa-receipt", color: "#ef4444", href: "/Gastos", desc: "Registro de gastos", enabled: !!user.menu_gastos },
    ]},
    { section: "Catálogos", items: [
      { label: "Categorias", icon: "far fa-list-alt", color: "#64748b", href: "/Categorias", desc: "Categorias", enabled: !!user.menu_gastos },
      { label: "SubCategorias", icon: "fas fa-list-ol", color: "#64748b", href: "/SubCategorias", desc: "Subcategorias", enabled: !!user.menu_gastos },
      { label: "Solicitantes", icon: "fas fa-user", color: "#64748b", href: "/Solicitantes", desc: "Solicitantes", enabled: !!user.menu_gastos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Gastos"
      descripcion="Registro y catalogos de gastos"
      icono="fas fa-receipt"
      color="#ef4444"
      secciones={SECCIONES}
    />
  );
}

export default BotonesGastos;
